import { derivePaymentMethodDescriptor } from "../utils/paymentMethodDescriptor.js";
function useSubscriptionPaymentMethodCard(subscription) {
    const { network, label, lastFour } = derivePaymentMethodDescriptor(subscription.data.paymentInformation);
    return {
        network,
        label,
        maskedLast4: lastFour
    };
}
export { useSubscriptionPaymentMethodCard };
